/**
 * Registry of static map overlay layers (JSON under public/layers/).
 * Add a row and ship a new JSON file to add a category.
 *
 * Marker tap UI: `LayerMarkerDetailModal` uses `categoryId` to pick layer-specific
 * content (e.g. `gme_teaching_hospitals` → CMS/GME layout; others use generic lines + meta).
 */
export const MAP_LAYERS = [
  {
    categoryId: "em_residencies",
    categoryLabel: "Emergency Medicine Residencies",
    dataUrl: "/layers/em_residencies.json",
    markerColor: "#C0392B",
    markerIcon: "hospital",
    overlayMenuRequiresMarkers: true,
  },
  {
    categoryId: "em_participating_sites",
    categoryLabel: "Hospitals with EM Residents (All Sites)",
    dataUrl: "/layers/em_participating_sites.json",
    markerColor: "#884EA0",
    markerIcon: "hospital",
    overlayMenuRequiresMarkers: true,
  },
  // Modal reads marker.meta.hasEmergencyDepartment (or hasEr) for ER Yes/No when the layer pipeline adds CMS facility ER data.
  {
    categoryId: "gme_teaching_hospitals",
    categoryLabel: "Teaching Hospitals (All GME)",
    dataUrl: "/layers/gme_teaching_hospitals.json",
    markerColor: "#117A65",
    markerIcon: "hospital",
    overlayMenuRequiresMarkers: true,
  },
];